<template>
<!-- Note: Elements should be 48px heigh normally, or 32px when small height -->

<div :class="elementOuterClass" :style="elementOuterStyle">

<div :style="elementStyle" :class="elementClass" @click="elementClicked">
    <template v-if="element.type == 'Text'">
        <v-text-field v-model="element.value" :label="element.title" :disabled="disabled" :hide-details="hideDetails" :single-line="singleLine" />        
    </template>
    <template v-if="element.type == 'List'">
        <v-select v-model="element.value" :items="options" :label="element.title" :disabled="disabled" :hide-details="hideDetails" :single-line="singleLine" />        
    </template>
    <template v-if="element.type == 'Checkbox'">
        <v-checkbox v-model="element.value" :label="element.title" :disabled="disabled" :hide-details="hideDetails" color="primary" />        
    </template>
    <template v-if="element.type == 'Html'">
        <div class="grey--text text--darken-2" v-html="htmlValue" :hide-details="hideDetails" />      
    </template>
</div>
</div>

</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import OrderHelpers from '../helpers/OrderHelpers';

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        element: Object,
        settings: Object,
    },

    computed: {
        options() {
            return (this.element.options || String('')).split(',').map(s => s.trim())
        },

        elementOuterStyle() {
            return {
                'width': this.settings.narrow ? '100%' : this.element.width + '%'
                // 'width': this.element.width + '%'
            }
        },
        elementStyle() {
            let style = {
                // 'flex-grow': 1,
                'border-style': 'dashed',
                'border-width': '2px',
                'border-color': (this.settings.editing ? '#ddd' : 'transparent'),
                'padding': '3px',
                'border-radius': '3px',
            }
            
            let borderColour = 'transparent'
            if(this.settings.editing) {

                if(this.settings.elementEditing == this.element)
                    borderColour = '#1976d2'
                else
                    borderColour = '#ddd'
            }
            style['border-color'] = borderColour
            
            return style
        },
        elementClass() {
            let classString = "element-inner"
            return classString
        },
        elementOuterClass() {
            let classString = "element-outer"
            if(this.element.height == 'S')
                classString += ' height-small'
            return classString
        },
        disabled() {
            return this.settings.editing || this.element.disabled
        },
        hideDetails() {
            return this.element.height != 'L'
        },
        singleLine() {
            return this.element.height == 'S'
        },
        htmlValue() {
            if(this.element.value)
                return this.element.value
            if(this.element.defaultValue)
                return this.element.defaultValue
            return '[No Value]'
        }
    },

    methods: {
        elementClicked(element) {
            this.$emit('click', this.element)
        },
    },

    created() {

    }
}
</script>

<style scoped>

    .element-outer {padding:0px 5px;}
    .height-normal {background-color:yellow;margin-bottom:-20px}
    
    .height-small .v-text-field {padding-top:0px!important; margin-top:0px}

    .v-input--checkbox {margin-bottom:4px}
    .height-small .v-input--checkbox {margin-top:0px;}
</style>




// WEBPACK FOOTER //
// ControlElement.vue?4c48f912